import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Game.module.css';

const game = (props) => {
    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (props.selected === 'NewGameList') {
        header_icon = (<div className={classes.AddCircle}><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }
    return (
        <div className={"card "+ classes.Game +" "+props.selected} onClick={props.clicked}>
            <h4 className="card-header">{props.name} {header_icon}</h4>
            <div className="card-body">
                <div className={"cardText "+classes.truncate}>{props.description}</div>
            </div>
        </div>
    );
};

export default game;